import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import SeoHead from './components/SeoHead';
import { OrganizationSchema } from './components/JsonLd';
import Home from './pages/Home';
import Services from './pages/Services';
import Clients from './pages/Clients';
import UseCases from './pages/UseCases';
import UseCaseDetail from './pages/UseCaseDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import ChatBubble from './components/ChatBubble';
import Footer from './components/Footer';
import ErrorPage from './pages/ErrorPage';

function MainPage() {
  return (
    <main>
      <section id="home" className="min-h-screen">
        <Home />
      </section>

      <section id="services" className="min-h-screen py-16">
        <Services />
      </section>

      <section id="clients" className="py-4">
        <Clients />
      </section>

      <section id="about" className="min-h-screen py-16">
        <About />
      </section>

      <section id="contact" className="min-h-screen py-16">
        <Contact />
      </section>
    </main>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="min-h-screen" style={{ background: 'var(--color-bg)' }}>
          <SeoHead
            title="Colibri Technologies | IoT, Integration & Solutions Digitales — Montreal"
            description="Experts en IoT industriel, integration d'APIs, applications mobiles et web. Nous accelerons votre transformation digitale depuis Montreal, Quebec."
            canonical="/"
          />
          <OrganizationSchema />
          <Navbar />
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/use-cases" element={<UseCases />} />
            <Route path="/use-cases/:slug" element={<UseCaseDetail />} />
            {/* Error pages – also served via Apache ErrorDocument directives in .htaccess */}
            <Route path="/400" element={<ErrorPage code={400} />} />
            <Route path="/401" element={<ErrorPage code={401} />} />
            <Route path="/403" element={<ErrorPage code={403} />} />
            <Route path="/404" element={<ErrorPage code={404} />} />
            <Route path="/500" element={<ErrorPage code={500} />} />
            {/* Catch-all: unknown routes → 404 */}
            <Route path="*" element={<ErrorPage code={404} />} />
          </Routes>
          <Footer />
          <ChatBubble />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
